import React from 'react'
import styled from 'styled-components'

import Input from 'components/reusable/input/components/TextInput'
import AmPm from './components/am_pm'
import SvgClockOutline from 'components/reusable/svg/svg_clock_outline'
import { colors } from 'helpers/colors'

export const timeInputIcons = { amPm: 'am-pm-interface', clock: 'clock-icon' }

const TimeInput = ({ iconVersion = timeInputIcons.amPm, value, onChange, type, right = '4px', ...props }) => {
  let TimeIcon = null
  if (iconVersion === timeInputIcons.amPm)
    TimeIcon = (
      <AmPmWrapper $right={right}>
        <AmPm onChange={onChange} value={value} />
      </AmPmWrapper>
    )
  else if (iconVersion === timeInputIcons.clock)
    TimeIcon = (
      <IconWrapper>
        <SvgClockOutline color={colors.light} size={20} />
      </IconWrapper>
    )

  return (
    <Input type={type} onChange={onChange} value={value} {...props}>
      {TimeIcon}
    </Input>
  )
}

const AmPmWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: ${({ $right }) => $right};
  top: 50%;
  transform: translateY(-50%);
`

const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.gray[500]};
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
`

export default TimeInput
